

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);




//////////////////
// WEBPACK FOOTER
// ../node_modules/call-bind-apply-helpers/actualApply.js
// module id = ../node_modules/call-bind-apply-helpers/actualApply.js
// module chunks = 0